import defaultsDeep from "lodash/defaultsDeep";

const addVModelWatchersDefaults = {
    modelProp: "value",
    modelDataName: "dataValue"
};

export default function addVModelWatchers(options = {}) {
    var {modelProp, modelDataName} = defaultsDeep(options, addVModelWatchersDefaults);
    var modelPropName, modelPropConfig;

    if(typeof modelProp == "string") {
        modelPropName = modelProp;
    } else {
        modelPropName = modelProp.name;
        modelPropConfig = modelProp.config;
    }

    var eventName = "update:" + modelPropName;

    return {
        props: modelPropConfig == null ? [modelPropName] : {
            [modelPropName]: modelPropConfig
        },
        emits: [eventName],
        data: function() {
            return {
                [modelDataName]: null
            };
        },
        watch: {
            [modelDataName]: {
                handler: function(val, oldVal) {
                    if (val != oldVal) this.$emit(eventName, val);
                },
                deep: true,
            },
            [modelPropName]: {
                handler: function(val) {
                    this[modelDataName] = val;
                },
                deep: true,
                immediate: true
            }
        }
    }
}